import * as React from 'react';
import { Link } from 'react-router-dom';
import { Svg } from 'src/components/shared/Svg';

interface IProfileNavLinkProps {
  isActive: boolean;
  label: string;
  pathname: string;
  src: string;
  isLast?: boolean;
}

export const ProfileNavLink: React.SFC<IProfileNavLinkProps> = ({
  isActive,
  label,
  pathname,
  src,
  isLast,
}) => (
  <Link
    className={`w-100 ${isLast ? 'mt-5 pt-5' : ''}`}
    to={`/profile/${pathname}`}
  >
    <div className='position-relative d-flex flex-column justify-content-around align-items-center mt-5'>
      <Svg width={48} height={48} fill='dark' src={src} style={{ zIndex: 1 }} />
      <span
        className='text-center text-dark mt-2'
        style={{ textTransform: 'none', zIndex: 1 }}
      >
        {label}
      </span>
      {isActive && (
        <Svg
          className='position-absolute'
          width={180}
          height={180}
          fill='light'
          src='bulle-nav'
          style={{ top: '-30px' }}
        />
      )}
      <span
        className={`position-absolute nav-dot bg-${
          isLast ? 'dark' : 'warning'
        }`}
        style={{ right: '-27px', bottom: '-10px' }}
      />
    </div>
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileNav/ProfileNavLink.tsx